import React, { FC } from 'react'
import Popup from 'reactjs-popup'
import { useDispatch, useSelector } from '../../../store'
import { hideSuccessModalAction } from '../../../store/application/slice'

import './ActionStatusModal.scss'

// TODO clear popup
const ActionStatusModal: FC<any> = ({ dipatch }) => {
  const { isOpen, message } = useSelector(({ app: { successModal } }) => successModal)

  const dispatch = useDispatch()

  const hideSuccessModal = () => {
    dispatch(hideSuccessModalAction())
  }

  return (
    <Popup open={isOpen} className='success-modal' closeOnDocumentClick={false}>
      <div className='success-modal__close-button' onClick={hideSuccessModal} />
      <div className='success-modal__content'>
        <div className='success-modal__content__icon' />
        <div className='success-modal__content__message'>{message}</div>
      </div>
    </Popup>
  )
}

export default ActionStatusModal
